import Client from "../client/FireBase"

const createTokenFirebase = (data) => {
  return Client.post(`api/device`, data)
}
const userRepository = {
  createTokenFirebase
}
export default userRepository
